<!-- START HEADER-->
<header class="header" app-header [toggleSideMenu]="getToggleSideMenu()"></header>
<!-- END HEADER-->
<!-- START SIDEBAR-->
<nav id="sidebar" app-sidebar [collapsed]="sideMenuCollapsed"></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper" [ngClass]="{ 'collapsed': !sideMenuCollapsed }">
  <router-outlet></router-outlet>
  <!-- <footer class="page-footer" app-footer></footer> -->
</div>
<!-- END PAGE CONTENT-->
